/* pz-quiz.js - facet quiz. No product data here; everything comes from data attributes
   rendered by pz-quiz.liquid from product metafields + live inventory. */
(function () {
  function init(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
    var results = root.querySelector('[data-results]');
    var empty = root.querySelector('[data-empty]');
    var stageWrap = root.querySelector('[data-stage-wrap]');
    var backBtn = root.querySelector('[data-back]');
    var progress = root.querySelector('[data-progress]');
    var max = parseInt(root.getAttribute('data-max'), 10) || 3;
    var pool = document.createDocumentFragment();
    cards.forEach(function (c) { pool.appendChild(c); });
    var i = 0, answers = {};

    function show() {
      steps.forEach(function (s, n) { s.hidden = n !== i; });
      if (stageWrap) stageWrap.hidden = false;
      results.hidden = true;
      empty.hidden = true;
      if (backBtn) backBtn.hidden = i === 0;
      if (progress) progress.textContent = steps.length > 1 ? 'Step ' + (i + 1) + ' of ' + steps.length : '';
    }

    function render() {
      steps.forEach(function (s) { s.hidden = true; });
      if (stageWrap) stageWrap.hidden = true;
      var keys = Object.keys(answers);
      var scored = cards.map(function (c) {
        var score = 0, keep = true;
        keys.forEach(function (k) {
          var raw = c.getAttribute('data-' + k) || '';
          var hit = raw.split('|').indexOf(answers[k]) > -1;
          if (hit) score++;
          if (k === 'concern' && !hit) keep = false;
        });
        return { el: c, score: score, keep: keep };
      }).filter(function (x) { return x.keep; })
        .sort(function (a, b) { return b.score - a.score; });

      while (results.firstChild) pool.appendChild(results.firstChild);
      var n = 0;
      scored.forEach(function (x) {
        if (n < max) { x.el.hidden = false; results.appendChild(x.el); n++; }
      });
      if (n === 0) { empty.hidden = false; } else { results.hidden = false; }
      var top = root.getBoundingClientRect().top + window.pageYOffset - 24;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var opt = t.closest('[data-opt]');
      if (opt && root.contains(opt)) {
        var facet = opt.getAttribute('data-facet');
        answers[facet] = opt.getAttribute('data-opt');
        var sibs = opt.parentNode.querySelectorAll('[data-opt]');
        Array.prototype.forEach.call(sibs, function (x) {
          x.setAttribute('aria-pressed', x === opt ? 'true' : 'false');
        });
        if (i < steps.length - 1) { i++; show(); } else { render(); }
        return;
      }
      if (t.closest('[data-back]')) { i = Math.max(0, i - 1); show(); return; }
      if (t.closest('[data-restart]')) {
        i = 0; answers = {};
        Array.prototype.forEach.call(root.querySelectorAll('[data-opt]'), function (x) {
          x.setAttribute('aria-pressed', 'false');
        });
        show();
      }
    });

    show();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pz-quiz]'), function (r) {
      if (!r.hasAttribute('data-pz-ready')) { r.setAttribute('data-pz-ready', '1'); init(r); }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
